export const ENV_PROD = 'production';
export const ENV_PREPROD = 'preprod';
export const ENV_DEV = 'development';
export const ENV_PLAYWRIGHT = 'playwright';

export function getEnvDomain(): string {
    switch (window.__TOTENV__.ENV) {
        case ENV_PROD:
            return 'admin.totem.co';
        case ENV_PREPROD:
            return 'admin-preprod.totem.co';
        case ENV_DEV:
        default:
            return 'localhost:3000';
    }
}
